import { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

interface Props {
  show: boolean;
  onHide: () => void;
}

export default function ForgotPasswordModal({ show, onHide }: Props) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement actual password reset API call
    // For now, just show success message
    setSent(true);
  };

  const handleClose = () => {
    setEmail("");
    setSent(false);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="forgot-password-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Reset your password</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {sent ? (
          <Alert variant="success">
            <i className="bi bi-check-circle me-2" />
            We&rsquo;ve sent a password reset link to <strong>{email}</strong>.
            Please check your inbox and follow the instructions to reset your
            password.
          </Alert>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
              <Form.Text className="text-muted">
                Enter the email address associated with your account and
                we&rsquo;ll send you a link to reset your password.
              </Form.Text>
            </Form.Group>

            <div className="d-grid">
              <Button variant="primary" type="submit">
                Send reset link
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>

      {sent && (
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}
